export default "__VITE_ASSET__s$nGAafv__"